
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/selection.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-selection-demo-plugin-selection"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/selection.en.md?type=demo')
};